import { API_BASE } from "./api";
import { APP_PLATFORM, APP_VARIANT, APP_VERSION_CODE, IS_MOBILE_APP } from "./appVariant";

const CHECK_TIMEOUT_MS = 8000;

export async function checkAppUpdate() {
  if (!IS_MOBILE_APP) return { required: false, skipped: true };

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), CHECK_TIMEOUT_MS);

  try {
    const q = new URLSearchParams({
      app_type: APP_VARIANT,
      platform: APP_PLATFORM,
    });

    const response = await fetch(`${API_BASE}/app_version.php?${q.toString()}`, {
      method: "GET",
      cache: "no-store",
      signal: controller.signal,
      headers: { Accept: "application/json" },
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok || data?.status !== "ok") {
      throw new Error(data?.message || "Version check unavailable");
    }

    // A release becomes mandatory ONLY when the installed version is below
    // minimum_version_code. latest_version_code by itself never blocks login.
    const minimum =
      Number.parseInt(data.minimum_version_code ?? "0", 10) || 0;
    const latest =
      Number.parseInt(data.latest_version_code ?? "0", 10) || 0;

    const required =
      data.configured !== false &&
      minimum > 0 &&
      APP_VERSION_CODE > 0 &&
      APP_VERSION_CODE < minimum;

    const available =
      data.configured !== false &&
      latest > 0 &&
      APP_VERSION_CODE > 0 &&
      APP_VERSION_CODE < latest &&
      !required;

    return {
      required,
      available,
      minimumVersionCode: minimum,
      latestVersionCode: latest,
      message:
        data.update_message ||
        "A new version of MFSetu is required. Please update to continue.",
      storeUrl: data.store_url || "",
    };
  } finally {
    clearTimeout(timer);
  }
}
